import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PdfUploadIcon } from '@uplift/icons';
import { MAX_PDF_UPLOAD_SIZE } from '@uplift/constants';
import { SimpleDropzone, DropzoneErrorCode } from './SimpleDropzone.component';

export { DropzoneErrorCode } from './SimpleDropzone.component';


const useStyles = makeStyles()(theme => ({
  textContainer: {
    userSelect: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  icon: {
    fontSize: '48px',
    color: theme.palette.grey[700]
  },
  browseButton: {
    position: 'relative',
    cursor: 'pointer',

    '&:after': {
      content: '""',
      backgroundColor: 'currentColor',
      position: 'absolute',
      width: '100%',
      height: '1px',
      left: 0,
      bottom: '2px',
    }
  }
}));


const DropzoneMessage: React.VFC<{ isActive: boolean; isReject: boolean }> = ({ isActive, isReject }) => {
  const { classes } = useStyles();

  if (isActive) {
    if (isReject) {
      return (
        <Typography color="textPrimary">
          <span style={{ fontWeight: 600 }}>File format is not allowed</span>
        </Typography>
      );
    }

    return (
      <Typography color="textPrimary">
        <span style={{ fontWeight: 600 }}>Drop file here</span>
      </Typography>
    );
  }

  return (
    <Typography color="textPrimary">
      <span style={{ fontWeight: 600 }}>Drag & drop here, or&nbsp;</span><Typography component="span" color="secondary" className={classes.browseButton}>Browse</Typography>
    </Typography>
  );
};


export type DocumentDropzoneProps = {
  onFiles: (files: File[]) => void;
  onError: (error: DropzoneErrorCode) => void;
};


export const DocumentDropzone: React.FC<DocumentDropzoneProps> = (props) => {
  const { classes, cx } = useStyles();

  return (
    <SimpleDropzone
      maxSize={MAX_PDF_UPLOAD_SIZE}
      accept={{ 'application/pdf': [ '.pdf' ] }}
      onDropAccepted={props.onFiles}
      onDropRejected={rejected => {
        props.onError(rejected?.[0]?.errors?.[0].code as DropzoneErrorCode);
      }}
    >
      {state => (
        <Box className={cx(classes.textContainer)}>
          <PdfUploadIcon className={classes.icon} />
          <DropzoneMessage
            isActive={state.isDragActive}
            isReject={state.isDragReject}
          />
          <Typography variant="body2">Must be a PDF less than 10 MB</Typography>
        </Box>
      )}
    </SimpleDropzone>
  );
};
